<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li><a routerLink="/tramites-configuracion">Configuración de Beneficios</a></li>
                <li><a routerLink="/adjuntos-configuracion">Configuración de Adjuntos</a></li>
                <li>Listado de Adjuntos</li>
            </ul>
            <h2>Adjuntos para beneficios</h2>
        </div>
    </div>
</div>

<app-loading *ngIf="!flagLoaded" class="m-5"></app-loading><br>

<div *ngIf="flagLoaded" class="profile-area pb-70 contenido-tabla">
    <div class="container">

        <div class="profile-courses-quizzes">
            <h3>Listado de Adjuntos</h3>
            <hr>
            <div *ngIf="flagLoaded">
                <mat-form-field>
                    <mat-label>Filtrar</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Certificado de..." autocomplete="off">
                </mat-form-field>
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                    <!-- Column -->
                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                    </ng-container>
                    <!-- Column -->
                    <ng-container matColumnDef="descripcion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción </th>
                        <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                    </ng-container>
                    <!-- Column -->
                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="verAdjunto(element._id)" type="button" class="btn btn-warning"><i class="fas fa-edit"></i></button>
                        </td>
                    </ng-container>          
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
            </div>
        </div>
    </div>
</div>
